/**
 * Admin GET endpoint — fetches a page by pageId (not slug) and includes
 * BOTH the current PUBLISHED and the working DRAFT so the editor can warn
 * about unsaved/unpublished changes.
 */

import { z } from 'zod'

import { PageTemplateSchema, PageVisibilitySchema } from '../../schemas/entities/page'

export const GetPageForAdminParamsSchema = z.object({
  schoolPublicId: z.string().min(1),
  pageId: z.string().min(1)
})
export type GetPageForAdminParams = z.infer<typeof GetPageForAdminParamsSchema>

const VersionSchema = z.object({
  publicId: z.string(),
  content: z.unknown(),
  publishedAt: z.string().datetime().nullable().optional(),
  updatedAt: z.string().datetime().optional()
})

export const GetPageForAdminResponseSchema = z.object({
  publicId: z.string(),
  slug: z.string(),
  title: z.string(),
  template: PageTemplateSchema,
  visibility: PageVisibilitySchema,
  draft: VersionSchema.nullable(),
  published: VersionSchema.nullable()
})
export type GetPageForAdminResponse = z.infer<typeof GetPageForAdminResponseSchema>
